import LangSwitcher from '@components/labels/LangSwitcher';
import { NorbecLogoSmall, SizeItLogoSmall, NorbecSizeItLogo, NorbecLogoBig  } from '@components/svg';
import { useLocale } from '@i18n';
import React from 'react';
import S from './styles/LeftContentAuthHalfAndHalf.styl';

interface ILeftContentAuthHalfAndHalffProps {
	children?: React.ReactElement;
}

export default function LeftContentAuthHalfAndHalf(props: ILeftContentAuthHalfAndHalffProps) {
	const T = useLocale();

	return (
		<div className={S.leftAuthContainer}>
			<div className={S.leftAuthContainerHeader}>
				<div className={S.leftAuthContainerHeaderLang}>
					<LangSwitcher />
				</div>
			</div>

			<div className={S.leftAuthContainerContent}>
				
				<div className={S.leftAuthContainerContentBrandRow}>
					<NorbecLogoBig color="white" />
					<SizeItLogoSmall color="white" />
				</div>
                {/* <NorbecSizeItLogo color="white" className={S.leftAuthContainerContentBrandLogo} /> */}
				<p className={S.leftAuthContainerContentText}>
					{T.OnboardingHalfHalfTitle}
				</p>
			</div>

			<div className={S.leftAuthContainerFooterLogo}>
				<NorbecLogoSmall color={'white'}/>
			</div>
		</div>
	);
}
